import { React, useEffect, useState, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  TableLayoutData,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Radio,
  Tabs,
  Tooltip
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles, StyledTab } from "../../pageStyled";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { useLocation, useNavigate } from "react-router";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";

import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import { Country, State } from "country-state-city";
import { capital_letter } from "../../../Utils/helper/helper";
import { addRewinder, deleteRewinderByCode, getAllRewinder, getRewinderByCode, updateRewinderByCode, paperMachineListDataForConfiguration } from "../../../Services/machineServices";
import { getUnitData } from '../../../Services/measurementService';
import { CoversionFactorCMToUnits, CoversionFactorUnitsToCM, lengthUnit, weightUnit } from '../../../Utils/Constant/MeasurementUnitList.jsx';
import {
  PaperMachineQualitySelect,
  PaperMachineGradeSelect,
} from "../../pageStyled";
import Multiselect from "multiselect-react-dropdown";
import styled from "styled-components";
const Panes = Tabs.TabPane;

const multiselectStyle = {
  chips: {},
  searchBox: {
    border: "none",

    "border-radius": "0px",
  },
  option: {
    // To change css for dropdown options
    //background : "gray"
  },
};

// const MultiSelectCard = styled.div`
//   .optionContainer li:hover,
//   .optionContainer .highlight {
//     background: #edebe9;
//     color: black;
//   }
//   .multiSelectContainer input[type="text"] {
//     padding-left: 15px !important;
//     width: 100%;
//   }
//   .optionContainer .highlight {
//     background: white;
//     color: black;
//   }
//   .optionListContainer {
//     z-index: 100;
//   }
//   li.groupHeading {
//     color: black;
//     padding: 5px 15px;
//     pointer-events: none;
//     font-weight: 500;
//   }
//   .multiSelectContainer ul {
//     border-radius: 0px;
//   }
//   .multiSelectContainer input[type="checkbox"] {
//     accent-color: rgb(234, 101, 91);
//   }
// `;

const MultiSelectCard = styled.div`
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: #edebe9;
    color: black;
  }
  .multiSelectContainer input[type="text"] {
    padding-left: 15px !important;
    width: 100%;
  }
  .optionContainer .highlight {
    background: white;
    color: black;
  }
  .optionListContainer {
    z-index: 100;
  }
  li.groupHeading {
    color: black;
    padding: 5px 15px;
    pointer-events: none;
    font-weight: 500;
  }
  .multiSelectContainer ul {
    border-radius: 0px;
  }
  .multiSelectContainer input[type="checkbox"] {
    accent-color: rgb(234, 101, 91);
  }
`;

/* Table wrapper */
export const DeckleWrapper = styled.div`
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
`;

/* Base row (header + body) */
export const DeckleTableRow = styled(Row)`
  margin: 0 !important;
`;

/* Header row */
export const DeckleHeaderRow = styled(DeckleTableRow)`
  background: #fafafa;
  font-weight: 500;
  color: #555;
  border-bottom: 1px solid #d9d9d9;
`;

/* Body row */
export const DeckleBodyRow = styled(DeckleTableRow)`
  border-bottom: 1px solid #d9d9d9;

  &:last-child {
      border-bottom: none;
    }
`;

/* Column styling (vertical lines) */
export const DeckleColStyle = `
  border-right: 1px solid #d9d9d9;
  padding: 10px;
  display: flex;
  align-items: center;

  &:last-child {
    border-right: none;
  }
`;

/* Wrapper to apply col styles */
export const DeckleColWrapper = styled.div`
  .ant-col {
    ${DeckleColStyle}
    padding: 10px 5px !important;
  }
`;

/* Min / Max input stack */
export const DeckleWidthInputs = styled.div`
  // display: flex;
  // flex-direction: column;
  // gap: 6px;


  //new commented working one
  display: flex;
  gap: 8px;
  width: 100%;

  .ant-input {
    flex: 1;
    min-width: 0; /* prevents overflow in Col */
  }
`;

/* Optional input polish */
export const DeckleTableContainer = styled.div`
  .ant-input {
    height: 32px;
  }
`;


const { Option } = Select;
const provinceData = ["India", "USA"];

const userStatusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];

const plyStatusData = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

const setupData = [
  { label: "Single Multi-Ply Jumbo Roll", value: "single" },
  { label: "Multiple Loading Stands", value: "multiple" },
];
const allowedValues = [1, 2, 3, 4];
const { TextArea } = Input;

const AddEditViewRewinder = (props) => {
  const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const history = useNavigate();
  const location = useLocation();
  const [plyStatus, setPlyStatus] = useState(location.state.action == 'add' ? plyStatusData[1].value : '');
  const deckleWidthUnitData = ["mm", "cm"];
  const edgeUnitData = ["mm", "cm"];
  const [selectedLengthUnit, setSelectedLengthUnit] = useState();
  const selectedEdgeUnit = useRef("cm");
  const [addResp, setAddResp] = useState();
  const [addToastr, setAddToastr] = useState(false);
  const [form] = Form.useForm();
  const [gsmValidationError, setGSMValidationError] = useState(false);
  const [widthValidationError, setWidthValidationError] = useState(false);
  const [edgeTrimValidationError, setEdgeTrimValidationError] = useState(false);
  const [action, setAction] = useState(location.state.action);
  const [rewinderDetails, setRewinderDetails] = useState();
  const [visible, setVisible] = useState(false);
  const [viewDelete, setViewDelete] = useState(false);
  const [allRewinderData, setAllRewinderData] = useState([]);
  const [unitData, setUnitData] = useState();
  const [deleteToastr, setDeleteToastr] = useState(false);
  const [plySetup, setPlySetup] = useState();
  const [selectedPly, setSelectedPly] = useState('single');
  const [loadingStand, setLoadingStand] = useState();
  const [checkboxCount, setCheckboxCount] = useState(location.state.action == 'add' ? 4 : 0);
  const [selectedRange, setSelectedRange] = useState([]);
  const [paperMachines, setPaperMachines] = useState([]);
  const [conditionBasedMachines, setConditionBasedMachines] = useState([]);
  const [selectedPaperMachines, setSelectedPaperMachines] = useState([]);
  const [deckleSpecificationsData, setDeckleSpecificationsData] = useState([]);
  const [defaultActiveKey, setDefaultActiveKey] = useState("0");
  const [activeTab, setActiveTab] = useState("0");
  const [fixedEdgeTrimConfig, setFixedEdgeTrimConfig] = useState(false);
  const [multiplySetup , setMultiplySetup] = useState('single');

  useEffect(() => {
    (async () => {

      getUnitData().then((response) => {
        setUnitData(response.data);
        if (action == 'add') {
          setSelectedLengthUnit(response.data.units_management.length.default);
        }
      })
        .catch((error) => {
          console.log(error);
        });

      const records = await paperMachineListDataForConfiguration();
      if (records?.length) {
        setPaperMachines(records);
      } else {
        setPaperMachines([]);
      }

      await getAllRewinder()
        .then((response) => {
          setAllRewinderData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });

      if (action === "view" || action === 'edit')
        await getRewinderByCode(location.state.code)
          .then((response) => {
            setRewinderDetails(response.data);
            setSelectedLengthUnit(response.data.units.effective_deckle_length);
            setSelectedRange(response.data.ply ? response.data.ply : []);
            setPlySetup(response.data.multi_ply_setup);
            setPlyStatus(response.data.multi_ply_capability);
            setFixedEdgeTrimConfig(response.data.fixed_edge_trim);
            form.setFieldsValue({
              fixed_edge_trim_config: response.data.fixed_edge_trim
            });
            if(response.data.multi_ply_setup == 'single')
            {
              setCheckboxCount(4)
            }
            else
            {
              setCheckboxCount(response.data.loading_stands);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    })();

  }, []);

  useEffect(() => {
    if (paperMachines?.length && rewinderDetails && (action === "view" || action === 'edit')) {
      let filteredMachines;
      if (rewinderDetails?.maximum_gsm && rewinderDetails?.minimum_gsm) {
        filteredMachines = paperMachines
          .filter(
            ele =>
              ele?.minimum_gsm >= rewinderDetails?.minimum_gsm &&
              ele?.maximum_gsm <= rewinderDetails?.maximum_gsm
          )
          .map(ele => ({
            ...ele,
            displayName: `${ele.code} - ${ele.name}`
          }));

        setConditionBasedMachines(filteredMachines);
      }

      let machineCodes = Object.keys(rewinderDetails?.gsm_wise_configs);
      const matchingMachines = filteredMachines?.filter(machine => machineCodes?.includes(machine.code));
      setSelectedPaperMachines(matchingMachines);

      if (rewinderDetails?.gsm_wise_configs) {
        const machinesData = machineCodes.map(code => {
          const widths = rewinderDetails.gsm_wise_configs[code].map(config => ({
            minimum_width: config.min_deckle_width,
            maximum_width: config.max_deckle_width,
            minimum_gsm: config.min_gsm,
            maximum_gsm: config.max_gsm,
            left_edge_trim: config.left_edge_trim,
            right_edge_trim: config.right_edge_trim,
            effective_deckle_length: config.effective_deckle_length,
            max_allowed_trim_loss: calculateMaximumTrimLoss(
              config.min_deckle_width,
              config.max_deckle_width
            ),
            unit:
              rewinderDetails.units.gsm_wise_configs[code]?.max_deckle_width ||
              "cm",
          }));

          return {
            code,
            name: paperMachines.find(m => m.code === code)?.name || code,
            widths,
          };
        });

        setDeckleSpecificationsData(machinesData);

        // set form fields
        const formValues = {};
        machinesData.forEach(machine => {
          machine.widths.forEach((width, idx) => {
            formValues[`${machine.code}minWidth${idx}`] = width.minimum_width;
            formValues[`${machine.code}maxWidth${idx}`] = width.maximum_width;
            formValues[`${machine.code}left_trim${idx}`] = width.left_edge_trim;
            formValues[`${machine.code}right_trim${idx}`] = width.right_edge_trim;
            formValues[`${machine.code}effective_dlength${idx}`] = width.effective_deckle_length;
            formValues[`${machine.code}trim_loss${idx}`] = width.max_allowed_trim_loss;
            formValues[`${machine.code}dlength_unit${idx}`] = width.unit;
            // formValues[`${machine.code}trim_loss_unit${idx}`] = width.unit;
          });
        });

        form.setFieldsValue(formValues);
      }
    }
  }, [paperMachines, rewinderDetails]);

  useEffect(() => {
    if (selectedPaperMachines?.length) {
      setActiveTab(selectedPaperMachines[0].code);
    }
  }, [selectedPaperMachines]);

  const routeBack = (action, response) => {
    history("../rewinder-records/");
  };

  const validateMinMaxGSM = () => {
    if (
      form.getFieldValue("minimum_gsm") &&
      form.getFieldValue("maximum_gsm") &&
      parseFloat(form.getFieldValue("maximum_gsm")) <
      parseFloat(form.getFieldValue("minimum_gsm"))
    ) {
      setGSMValidationError(true);
    } else {
      setGSMValidationError(false);
      selectedPaperMachines.forEach(machine => {
        clearMachineFormFields(machine.code);
      });
      setSelectedPaperMachines([]);
      fetchPaperMachines();
    }
  };

  const fetchPaperMachines = () => {
    let minGSM = form.getFieldValue("minimum_gsm");
    let maxGSM = form.getFieldValue("maximum_gsm");
    if (paperMachines?.length && minGSM && maxGSM) {
      const filteredMachines = paperMachines
        .filter(
          ele =>
            ele?.minimum_gsm >= minGSM &&
            ele?.maximum_gsm <= maxGSM
        )
        .map(ele => ({
          ...ele,
          displayName: `${ele.code} - ${ele.name}`
        }));

      setConditionBasedMachines(filteredMachines);
    }
  };

  const onChangeMachineSelect = (value) => {
    const machinesData = conditionBasedMachines
      ?.filter(machine => value.some(v => v.code === machine.code))
      .map(machine => {
        const widthsSource = machine.gsm_wise_deckle_enabled
          ? machine.gsm_wise_deckle_configs
          : [machine];

        return {
          code: machine.code,
          name: machine.name,
          gsm_wise_deckle_enabled: machine.gsm_wise_deckle_enabled,
          widths: widthsSource.map(item => {
            const minWidth = machine.gsm_wise_deckle_enabled
              ? item.min_deckle_width
              : item.minimum_width;

            const maxWidth = machine.gsm_wise_deckle_enabled
              ? item.max_deckle_width
              : item.maximum_width;

            const unit = machine?.gsm_wise_deckle_enabled
              ? machine?.units?.max_deckle_width
              : machine?.units?.maximum_width;

            return {
              minimum_width: minWidth,
              maximum_width: maxWidth,

              minimum_gsm: machine.gsm_wise_deckle_enabled
                ? item.min_gsm
                : item.minimum_gsm,

              maximum_gsm: machine.gsm_wise_deckle_enabled
                ? item.max_gsm
                : item.maximum_gsm,

              left_edge_trim: "",
              right_edge_trim: "",

              effective_deckle_length: "",
              max_allowed_trim_loss: calculateMaximumTrimLoss(
                minWidth,
                maxWidth),
              unit,
            };
          }),
        };
      });

    setDeckleSpecificationsData(machinesData);
    setSelectedPaperMachines(value);

    const formValues = {};
    machinesData.forEach(machine => {
      machine.widths.forEach((_, idx) => {
        formValues[`${machine.code}trim_loss${idx}`] =
          machine.widths[idx].max_allowed_trim_loss;
      });
    });

    form.setFieldsValue(formValues);
  };

  const onMachineDeSelect = (newSelected) => {
    const removedMachines = selectedPaperMachines.filter(
      old => !newSelected.some(n => n.code === old.code)
    );

    removedMachines.forEach(machine => {
      clearMachineFormFields(machine.code);
    });

    const formValues = form.getFieldsValue(true);

    const updatedDeckleData = deckleSpecificationsData
      .filter(m => newSelected.some(n => n.code === m.code))
      .map(machine => ({
        ...machine,
        widths: machine.widths.map((width, i) => ({
          ...width,
          minimum_width: formValues[`${machine.code}minWidth${i}`] ?? width.minimum_width,
          maximum_width: formValues[`${machine.code}maxWidth${i}`] ?? width.maximum_width,
          left_edge_trim: formValues[`${machine.code}left_trim${i}`] ?? "",
          right_edge_trim: formValues[`${machine.code}right_trim${i}`] ?? "",
          effective_deckle_length: formValues[`${machine.code}effective_dlength${i}`] ?? "",
          max_allowed_trim_loss: formValues[`${machine.code}trim_loss${i}`] ?? "",
          unit: formValues[`${machine.code}trim_loss_unit${i}`] ?? "",
        }))
      }));

    setDeckleSpecificationsData(updatedDeckleData);
    setSelectedPaperMachines(newSelected);
  };

  const clearMachineFormFields = (machineCode) => {
    const machine = deckleSpecificationsData?.find(m => m.code === machineCode);
    if (!machine) return;

    machine.widths.forEach((_, i) => {
      form.setFieldsValue({
        [`${machineCode}minWidth${i}`]: undefined,
        [`${machineCode}maxWidth${i}`]: undefined,
        [`${machineCode}left_trim${i}`]: undefined,
        [`${machineCode}right_trim${i}`]: undefined,
        [`${machineCode}effective_dlength${i}`]: undefined,
        [`${machineCode}trim_loss${i}`]: undefined
      });
    });
  };

  const validateEdgeTrim = () => {
    let lengthDivisor = CoversionFactorUnitsToCM[form.getFieldValue("length_unit")];
    let edgeDivisor = CoversionFactorUnitsToCM[form.getFieldValue("edge_unit")];
    if (
      form.getFieldValue("left_edge_trim") &&
      form.getFieldValue("right_edge_trim") &&
      form.getFieldValue("minimum_width") &&
      form.getFieldValue("maximum_width") &&
      (parseFloat(form.getFieldValue("left_edge_trim")) * edgeDivisor + parseFloat(form.getFieldValue("right_edge_trim")) * edgeDivisor) >=
      parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor - parseFloat(form.getFieldValue("minimum_width")) * lengthDivisor
    ) {
      setEdgeTrimValidationError(true);
    } else {
      setEdgeTrimValidationError(false);
    }
    calculateEffectiveLength();
  };

  const validateWidth = () => {
    if (
      form.getFieldValue("minimum_width") &&
      form.getFieldValue("maximum_width") &&
      parseFloat(form.getFieldValue("maximum_width")) <
      parseFloat(form.getFieldValue("minimum_width"))
    ) {
      setWidthValidationError(true);
    } else {
      setWidthValidationError(false);
    }
    validateEdgeTrim();
    calculateEffectiveLength();
    calculateMaxTrimLoss();

  };

  const calculateEffectiveLength = () => {
    if (
      form.getFieldValue("left_edge_trim") &&
      form.getFieldValue("right_edge_trim") &&
      form.getFieldValue("maximum_width")
    ) {
      let lengthDivisor = CoversionFactorUnitsToCM[form.getFieldValue("length_unit")];
      let edgeDivisor = CoversionFactorUnitsToCM[form.getFieldValue("edge_unit")];
      let length = (parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor) - ((parseFloat(form.getFieldValue("left_edge_trim")) * edgeDivisor) + (parseFloat(form.getFieldValue("right_edge_trim")) * edgeDivisor));
      form.setFieldsValue({ effective_deckle_length: (CoversionFactorCMToUnits[form.getFieldValue("length_unit")] * length).toFixed(3) });
    }
  };

  const calculateMaxTrimLoss = () => {
    if (
      form.getFieldValue("minimum_width") &&
      form.getFieldValue("maximum_width")) {
      let lengthDivisor = CoversionFactorUnitsToCM[form.getFieldValue("length_unit")];
      form.setFieldsValue({ maximum_loss: (([parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor - parseFloat(form.getFieldValue("minimum_width")) * lengthDivisor] * 100) / (parseFloat(form.getFieldValue("maximum_width")) * lengthDivisor)).toFixed(3) });
    }
  };

  const onLengthUnitChange = (e) => {
    form.setFieldsValue({ edge_unit: e });
    setSelectedLengthUnit(e);
    validateEdgeTrim();
    validateWidth();
    calculateEffectiveLength();
    calculateMaxTrimLoss();
  }

  const onEdgeUnitChange = (e) => {
    selectedEdgeUnit.current = e;
    validateEdgeTrim();
    validateWidth();
    calculateMaxTrimLoss();
    calculateEffectiveLength();
  }

  const onPlyStatusChange = (e) => {
    setPlyStatus(e.target.value);
  }
  const modalShow = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    setVisible(false);
    routeBack();
  };

  const modalShowDelete = () => {
    setViewDelete(true);
  };

  const modalCancelDelete = () => {
    setViewDelete(false);
  };

  const modalConfirmDelete = (code) => {
    // deleteCustomerRecord(code);
    setViewDelete(false);
    deleteRewinderByCode(rewinderDetails.code)
      .then((response) => {
        setAddResp(response.msg);
        setAddToastr(true);
        setTimeout(() => {
          setAddToastr(false);
          history("../rewinder-records")
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        // setAddResp(error.response.data.msg);
        setDeleteToastr(true);
        // setTimeout(() => {
        //   setDeleteToastr(false);
        // }, 2000);
        if (error?.response?.status == 500) {
          setAddResp("Something went wrong. Please try again");
        } else {
          setAddResp(error?.response?.data?.msg);
        }

        setTimeout(() => {
          setDeleteToastr(false);
          setAddResp("");
        }, 2000);
      });

  };

  //   // const showAddToaster = () => {
  //   //   setAddToaster(true);
  //   //   setTimeout(() => setAddToaster(false), 3000);
  //   // };

  //   const showEditToaster = () => {
  //     setEditToaster(true);
  //     setTimeout(() => setEditToaster(false), 3000);
  //     setTimeout(() => history("../customer-records/"), 3700);
  //   };

  const isMachineTableComplete = (machineCode) => {
    const fields = getCurrentTabTableFields(machineCode);
    const values = form.getFieldsValue(fields);

    return fields.every(
      field => values[field] !== undefined && values[field] !== ""
    );
  };

  const handleSubmit = async () => {
    for (const machine of selectedPaperMachines) {
      const isComplete = isMachineTableComplete(machine.code);

      if (!isComplete) {
        setAddResp(`Please complete all table values for ${machine.name}`);
        setDeleteToastr(true);
        setTimeout(() => setDeleteToastr(false), 3000);

        setActiveTab(machine.code);
        return;
      }
    }

    if (gsmValidationError || widthValidationError || edgeTrimValidationError) {
      setAddResp("Please resolve all validation errors before submitting");
      setDeleteToastr(true);
      setTimeout(() => setDeleteToastr(false), 2000);
      return;
    }

    // if(!gsmValidationError && !widthValidationError && !edgeTrimValidationError){
    form.submit();
    // }
  }

  const onFinish = async (e) => {
    // let req = {
    //   effective_deckle_length : parseFloat( e.effective_deckle_length) ,
    //   left_edge_trim : parseFloat( e.left_edge_trim),
    //   right_edge_trim :  parseFloat(e.right_edge_trim),
    //   maximum_cutters : parseFloat( e.maximum_cutters),
    //   maximum_gsm : parseFloat( e.maximum_gsm),
    //   maximum_loss : parseFloat( e.maximum_loss).toFixed(3),
    //   maximum_width :  parseFloat( e.maximum_width),
    //   minimum_gsm : parseFloat( e.minimum_gsm),
    //   minimum_width : parseFloat( e.minimum_width),
    //   capacity : parseFloat(e.capacity),
    //   name:capital_letter(e.name),
    //   remarks : e.remarks,
    //   status: e.status,
    //   multi_ply_capability : plyStatus,
    //   units : {
    //     effective_deckle_length : form.getFieldValue("length_unit"),
    //     left_edge_trim : form.getFieldValue("edge_unit") ,
    //     right_edge_trim : form.getFieldValue("edge_unit"),
    //     minimum_width :form.getFieldValue("length_unit"),
    //     maximum_width :form.getFieldValue("length_unit"),
    //     capacity : form.getFieldValue('capacity_unit')
    //   }
    // }

    const gsmWiseConfigs = deckleSpecificationsData.reduce((acc, machine) => {
      acc[machine.code] = machine.widths.map(width => ({
        min_gsm: Number(width.minimum_gsm),
        max_gsm: Number(width.maximum_gsm),
        min_deckle_width: Number(width.minimum_width),
        max_deckle_width: Number(width.maximum_width),
        left_edge_trim: Number(width.left_edge_trim || 0),
        right_edge_trim: Number(width.right_edge_trim || 0),
        effective_deckle_length: Number(width.effective_deckle_length || 0),
        max_allowed_trim_loss_percentage: Number(width.max_allowed_trim_loss || 0),
      }));

      return acc;
    }, {});

    const gsmWiseUnits = deckleSpecificationsData.reduce((acc, machine) => {
      if (!machine.widths?.length) return acc;

      const unit = machine.widths[0].unit;

      acc[machine.code] = {
        min_deckle_width: unit,
        max_deckle_width: unit,
        left_edge_trim: unit,
        right_edge_trim: unit,
        effective_deckle_length: unit,
      };

      return acc;
    }, {});

    let request = {
      name: capital_letter(e.name?.trim()),
      remarks: e.remarks,
      status: e.status,
      capacity : parseFloat(e.capacity),
      maximum_cutters: parseFloat( e.maximum_cutters),
      minimum_gsm: parseFloat(e.minimum_gsm),
      maximum_gsm: parseFloat(e.maximum_gsm),
      paper_machine_codes: selectedPaperMachines?.map(machine => machine.code),
      gsm_wise_configs: gsmWiseConfigs,
      multi_ply_capability : plyStatus,
      fixed_edge_trim: fixedEdgeTrimConfig,
      loading_stands : parseInt(e.loading_stands,10),

      units: {
        capacity : form.getFieldValue('capacity_unit'),
        gsm_wise_configs: gsmWiseUnits
      }
    };

    console.log(request);

    if(plyStatus == 'yes')
    {

    request['multi_ply_setup'] = e.setup;
    if(e.setup == 'multiple')
    {
      request['loading_stands'] = parseInt(e.loading_stands,10);
    }
    request['ply'] = selectedRange.map(str => parseInt(str, 10));
    }

    if (action === 'add') {
      addRewinder(request)
        .then((response) => {
          setAddResp(response.msg);
          setAddToastr(true);
          setTimeout(() => {
            setAddToastr(false);
            history("../rewinder-records")
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          setDeleteToastr(true);
          if (error?.response?.status == 500) {
            setAddResp("Something went wrong. Please try again");
          } else {
            setAddResp(error?.response?.data?.msg);
          }

          setTimeout(() => {
            setDeleteToastr(false);
            setAddResp("");
          }, 2000);
        });
    }

    if (action === "edit") {
      updateRewinderByCode(rewinderDetails.code, request)
        .then((response) => {
          setAddResp(response.msg);
          setAddToastr(true);
          setTimeout(() => {
            setAddToastr(false);
            history("../rewinder-records")
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          setDeleteToastr(true);
          if (error?.response?.status == 500) {
            setAddResp("Something went wrong. Please try again");
          } else {
            setAddResp(error?.response?.data?.msg);
          }

          setTimeout(() => {
            setDeleteToastr(false);
            setAddResp("");
          }, 2000);
        });
    }
  }

  const handleCheckboxChange = (e) => {
    setSelectedRange(e)
  }

  const handleEdit = () => {
    setAction("edit");
  }

  const onSetupChange = (e) => {
    setPlySetup(e);
    if (e == 'single') {
      setCheckboxCount(4)
      setSelectedRange([]);
      setMultiplySetup('single')
    }
    else {
      //form.setFieldsValue({ loading_stands: '1' })
      setCheckboxCount(form.getFieldValue('loading_stands'));
      setSelectedRange([]);
      setMultiplySetup('multi')
    }
  }

  const onLoadingStandChange = (e) => {
    setCheckboxCount(e.target.value);
  }

  const checkboxes = Array.from({ length: multiplySetup == 'single' ? 4 : checkboxCount }, (_, index) => (
    <Col span={6} key={index}>
      <Checkbox value={`${index + 1}`}> <span style={{ color: '#323130', fontSize: '14px', fontFamily: 'font-family: var(--sf-pro-text)', fontStyle: 'normal' }}>{index + 1}</span></Checkbox>
    </Col>
  ));

  const getCurrentTabTableFields = (tabCode) => {
    const machine = deckleSpecificationsData.find(m => m.code === tabCode);
    if (!machine) return [];

    const fields = [];

    machine.widths.forEach((_, i) => {
      fields.push(
        `${tabCode}minWidth${i}`,
        `${tabCode}maxWidth${i}`,
        `${tabCode}left_trim${i}`,
        `${tabCode}right_trim${i}`,
        `${tabCode}effective_dlength${i}`,
        `${tabCode}trim_loss${i}`,
        `${tabCode}trim_loss_unit${i}`,
        `${tabCode}dlength_unit${i}`
      );
    });

    return fields;
  };

  const handleTabChange = async (key) => {
    try {
      const fieldsToValidate = getCurrentTabTableFields(activeTab);

      // Validate ONLY current tab table
      await form.validateFields(fieldsToValidate);

      //Allow tab change
      setActiveTab(key);
    } catch { }

  };

  const calculateEffectiveDeckleLength = (maxWidth, leftTrim, rightTrim, unit) => {
    return (
      parseFloat(maxWidth || 0) -
      (parseFloat(leftTrim || 0) + parseFloat(rightTrim || 0))
    );
  };

  const calculateMaximumTrimLoss = (minWidth, maxWidth) => {
    if (!minWidth || !maxWidth) return "";

    const maxLoss = ((parseFloat(maxWidth) - parseFloat(minWidth)) * 100) / (parseFloat(maxWidth));

    return Number(maxLoss).toFixed(3);
  };

  const updateWidthField = (machineCode, widthIndex, fieldName, value) => {
    setDeckleSpecificationsData(prevData =>
      prevData.map(machine => {
        if (machine.code !== machineCode) return machine;

        const updatedWidths = machine.widths.map((widthRow, idx) => {
          if (idx !== widthIndex) return widthRow;

          // update the changed field first
          const updatedRow = {
            ...widthRow,
            [fieldName]: value,
          };

          // recalculate only if trim fields change
          if (
            fieldName === "left_edge_trim" ||
            fieldName === "right_edge_trim"
          ) {
            const effectiveLength = calculateEffectiveDeckleLength(
              updatedRow.maximum_width,
              updatedRow.left_edge_trim,
              updatedRow.right_edge_trim,
              updatedRow.unit
            );

            updatedRow.effective_deckle_length = effectiveLength;

            form.setFieldsValue({
              [`${machineCode}effective_dlength${widthIndex}`]: effectiveLength,
            });
          }


          //calculate trimloss if widths change
          if (
            fieldName === "minimum_width" ||
            fieldName === "maximum_width"
          ) {
            const maxTrimLoss = calculateMaximumTrimLoss(
              updatedRow.minimum_width,
              updatedRow.maximum_width
            );

            updatedRow.max_allowed_trim_loss = maxTrimLoss;

            form.setFieldsValue({
              [`${machineCode}trim_loss${widthIndex}`]: maxTrimLoss,
            });
          }

          return updatedRow;
        });

        return { ...machine, widths: updatedWidths };
      })
    );
  };

  return (((action === "view" || action === "edit") && rewinderDetails && plyStatus && selectedRange) ||
    action === "add") &&
    unitData ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={action === "view" && routeBack}
          title={action === "add" ? "Add a new rewinder" : rewinderDetails.name}
          extra={
            action === "add"
              ? [
                <Button key="1" className="textTypeBtn" onClick={modalShow}>
                  Cancel changes
                </Button>,
                <Button key="2" className="themeBtn" onClick={handleSubmit}>
                  <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                  Add Rewinder
                </Button>,
              ]
              : action === "edit"
                ? [
                  <Button key="1" className="textTypeBtn" onClick={modalShow}>
                    Cancel changes
                  </Button>,
                  <Button key="3" className="themeBtn" onClick={handleSubmit}>
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Save Rewinder
                  </Button>,
                ]
                : [
                  <Button
                    key="8"
                    className="themeBtn noBg"
                    onClick={modalShowDelete}
                  // disabled={!roles.edit}
                  >
                    <Iconmoon icon="delete" size={14} color="#EA655B" />
                    Delete Rewinder
                  </Button>,
                  <Button
                    key="5"
                    className="themeBtn"
                    onClick={handleEdit}
                  //disabled={!roles.edit}
                  >
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Edit Rewinder
                  </Button>,
                ]
          }
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details of rewinder will be used in deckle
                      matchinng records and reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {action !== "add" && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Rewinder Code</label>
                          <p>
                            This is an auto generated code to uniquely identify
                            the rewinder
                          </p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="code"
                            // rules={[{ required: true }]}
                            initialValue={rewinderDetails?.code}
                            className=""
                          >
                            <Input disabled />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Rewinder Name</label>
                        <p>The rewinder will be identified by this name</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message:
                                "Name can have a maximum of 50 characters",
                            },
                            {
                              validator(_, value) {
                                if (rewinderDetails) {
                                  if (value === rewinderDetails.name)
                                    return Promise.resolve();
                                }
                                if (
                                  value == null ||
                                  !allRewinderData.filter(
                                    (data) =>
                                      data.name.toUpperCase() ===
                                      value.toUpperCase()
                                  ).length
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "This name exists for another rewinder"
                                  );
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action === "add" ? "" : rewinderDetails.name
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              //   action === "view"
                              //     ? ""
                              //     :
                              "Enter name of the rewinder"
                            }
                            style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Rewinder Specification</h2>
                    <p>
                      The rewinder specification will be used to decide what can
                      be processed on this rewinder
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>GSM Range</label>
                        <p>The rewinder can process paper of this GSM range</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex twoFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DisabledStyles>
                              <Form.Item
                                name="minimum_gsm"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                    message:
                                      "Only numeric characters are allowed upto 3 decimal points",
                                  },
                                  // {
                                  //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                  //   message: "Min. GSM cannot be zero",
                                  // },
                                  {
                                    validator(_, value) {
                                      if (value && value == 0) {
                                        return Promise.reject(
                                          "Min. GSM cannot be zero"
                                        );
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : rewinderDetails?.minimum_gsm
                                }
                                className=""
                              >
                                <Input
                                  placeholder={"Min GSM"}
                                  disabled={action == "view"}
                                  className="disabled-check"
                                  onChange={validateMinMaxGSM}
                                //style={{ textTransform: "capitalize" }}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="maximum_gsm"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^(0|[1-9]\d*)(\.\d{1,3})?$/,
                                    message:
                                      "Only numeric characters are allowed upto 3 decimal points",
                                  },
                                  // {
                                  //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                  //   message: "Max. GSM cannot be zero",
                                  // },
                                  {
                                    validator(_, value) {
                                      if (value && value == 0) {
                                        return Promise.reject(
                                          "Max. GSM cannot be zero"
                                        );
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : rewinderDetails?.maximum_gsm
                                }
                                className=""
                              >
                                <Input
                                  disabled={action == "view"}
                                  className="disabled-check"
                                  placeholder={"Max GSM"}
                                  onChange={validateMinMaxGSM}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                        </Col>
                        {gsmValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max GSM cannot be less than Min GSM
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>

                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Rewinder Capacity</label>
                        <p>The daily rewinding capacity of the rewinder</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex twoFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DisabledStyles>
                              <Form.Item
                                name="capacity"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^[0-9]*$/,
                                    message: "Invalid format",
                                  },
                                  // {
                                  //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                  //   message: "Capacity cannot be zero",
                                  // },
                                  {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Capacity cannot be zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : rewinderDetails?.capacity
                                }
                                className=""
                              >
                                <Input
                                  placeholder={"Enter the prod. capacity"}
                                  disabled={action == "view"}
                                  className="disabled-check"
                                  //style={{ textTransform: "capitalize" }}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="capacity_unit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? unitData.units_management.weight.default
                                    : rewinderDetails?.units?.capacity
                                }
                                className=""
                              >
                                <Select
                                  placeholder="Unit"
                                  disabled={action == "view"}
                                  suffixIcon={<DownArrowDraw />}
                                >
                                  {unitData.units_management.weight.data.map(
                                    (weight) => (
                                      <Option key={weight}>
                                        {weightUnit[weight].displayName +
                                          " / day"}
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="centerAlign" style={{ borderBottom: "0px solid #edebe9"}}>
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Paper Machine associated with rewinder</label>
                        <p>Select paper machine associated with rewinder</p>
                      </div>
                    </Col>

                    <Col span={12}>
                      <div className="boxFormType">
                        <PaperMachineQualitySelect>
                          <MultiSelectCard>
                            <Multiselect
                              className="multiQuality"
                              options={conditionBasedMachines}
                              style={multiselectStyle}
                              showArrow
                              selectedValues={selectedPaperMachines}
                              displayValue="displayName"
                              showCheckbox
                              onSelect={onChangeMachineSelect}
                              onRemove={onMachineDeSelect}
                              hideSelectedList
                              keepSearchTerm
                              disable={action === "view"}
                            />
                          </MultiSelectCard>
                        </PaperMachineQualitySelect>
                      </div>
                    </Col>
                  </Row>

                  {selectedPaperMachines?.length > 0 && (
                    <Row>
                      <Col span={12} offset={12}>
                        <PaperMachineGradeSelect>
                          <div className="mainMachineGrade">
                            {(() => {
                              const visibleCount = 3; // Number of items to show before tooltip
                              const visibleItems = selectedPaperMachines.slice(0, visibleCount);
                              const hiddenItems = selectedPaperMachines.slice(visibleCount);

                              return (
                                <>
                                  {/* Show visible items */}
                                  {visibleItems.map((item) => (
                                    <span key={item.code} className="MachineGradeSelect-active">
                                      {item.displayName}

                                      {(action === "edit" || action === "add") && (
                                        <Button
                                          className="textTypeBtn textBtnIcon paperButtonBg"
                                          onClick={() => {
                                            const newSelected = selectedPaperMachines.filter(
                                              machine => machine.code !== item.code
                                            );
                                            onMachineDeSelect(newSelected);
                                          }}
                                          disabled={action === "view"}
                                        >
                                          <Iconmoon icon="wrong" size={14} color="#EA655B" />
                                        </Button>
                                      )}
                                    </span>
                                  ))}

                                  {/* Show tooltip if hidden items exist */}
                                  {hiddenItems.length > 0 && (
                                    <Tooltip
                                      title={hiddenItems.map(item => item.displayName).join(", ")}
                                    >
                                      <span
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          cursor: "pointer",
                                          marginTop: "6px"
                                        }}
                                      >
                                        & {hiddenItems.length} More
                                      </span>
                                    </Tooltip>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </PaperMachineGradeSelect>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup" style={{ borderBottom: (selectedPaperMachines?.length > 0) ? "0px solid #edebe9" : "1px solid #edebe9" }}>
                <Col span={8}>
                  <GroupTitle>
                    <h2>Deckle Specifications</h2>
                    <p>The deckle specifications will be used to define Left Edge and Right Edge trim for GSM Intervals of selected Paper Machines</p>
                  </GroupTitle>
                </Col>
              </Row>
              {selectedPaperMachines?.length ?
                (<Row gutter={[16, 16]} className="groupForm lastGroup" style={{ paddingBottom: "15px" }}>
                  <Col span={24}>
                    <StyledTab style={{ width: "100%" }}>
                      <Tabs
                        activeKey={activeTab}
                        defaultActiveKey={defaultActiveKey}
                        onChange={handleTabChange}
                        destroyInactiveTabPane={true}
                      >
                        {selectedPaperMachines?.map((tab) => (
                          <Panes tab={tab?.name} key={tab?.code}>
                            <DeckleWrapper>
                              <DeckleTableContainer>
                                <DeckleColWrapper>
                                  <DeckleHeaderRow>
                                    <Col span={3}>GSM Range</Col>
                                    <Col span={5}>Deckle Width</Col>
                                    <Col span={3}>Left Edge Trim</Col>
                                    <Col span={3}>Right Edge Trim</Col>
                                    <Col span={5}>Effective Deckle Length</Col>
                                    <Col span={5}>Max Allowed Trim Loss</Col>
                                  </DeckleHeaderRow>

                                  {deckleSpecificationsData
                                    ?.filter(item => item?.code === tab.code)
                                    .flatMap(item => item.widths)
                                    .map((widthEle, widthIndex) => (
                                      <DeckleBodyRow key={widthIndex}>
                                        <Col span={3}>{widthEle?.minimum_gsm} - {widthEle?.maximum_gsm}</Col>

                                        <Col span={5}>
                                          <DeckleWidthInputs>
                                            <Form.Item
                                              name={`${tab.code}minWidth${widthIndex}`}
                                              rules={[
                                                { required: true, message: "This field is required" },
                                                {
                                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                                  message: "Up to 3 decimal point values are accepted",
                                                },
                                                ({ getFieldValue }) => ({
                                                  validator(_, value) {
                                                    const max = Number(getFieldValue(`${tab.code}maxWidth${widthIndex}`)) || 0;
                                                    const leftTrim = Number(getFieldValue(`${tab.code}left_trim${widthIndex}`)) || 0;
                                                    const rightTrim = Number(getFieldValue(`${tab.code}right_trim${widthIndex}`)) || 0;

                                                    if (!value) return Promise.resolve();
                                                    if (Number(value) === 0) return Promise.reject(new Error("Min width cannot be zero"));
                                                    if (Number(value) >= max) return Promise.reject(new Error(`Min width must be less than Max width (${max})`));
                                                    if ((Number(leftTrim) + Number(rightTrim)) >= (Number(max) - Number(value))) {
                                                      return Promise.reject(new Error("Total edge trim must be less than difference of Deckle Width min and max"));
                                                    }
                                                    return Promise.resolve();
                                                  }
                                                })
                                              ]}
                                              initialValue={widthEle.minimum_width}
                                            >
                                              <Input size="small" placeholder="Min"
                                                disabled={action == "view"}
                                                onChange={e => updateWidthField(tab.code, widthIndex, "minimum_width", e.target.value)}
                                              />
                                            </Form.Item>

                                            <Form.Item
                                              name={`${tab.code}maxWidth${widthIndex}`}
                                              rules={[{ required: true, message: "This field is required" }]}
                                              initialValue={widthEle.maximum_width}
                                            >
                                              <Input size="small" placeholder="Max" disabled />
                                            </Form.Item>
                                          </DeckleWidthInputs>
                                        </Col>

                                        {/* Left Trim */}
                                        <Col span={3}>
                                          <Form.Item
                                            name={`${tab.code}left_trim${widthIndex}`}
                                            rules={[
                                              { required: true, message: "This field is required" },
                                              {
                                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                                message: "Up to 3 decimal point values are accepted",
                                              },
                                              // ({ getFieldValue }) => ({
                                              //     validator(_, value) {
                                              //       const rightTrim = (getFieldValue(`${tab.code}right_trim${widthIndex}`));
                                              //       const minWidth = Number(getFieldValue(`${tab.code}minWidth${widthIndex}`)) || 0;
                                              //       const maxWidth = Number(getFieldValue(`${tab.code}maxWidth${widthIndex}`)) || 0;

                                              //       if (!value) return Promise.resolve();

                                              //       if ((Number(value) + rightTrim) >= (maxWidth - minWidth)) {
                                              //         return Promise.reject(
                                              //           new Error("Total edge trim must be less than difference of Deckle Width min and max")
                                              //         );
                                              //       }

                                              //       return Promise.resolve();
                                              //     }
                                              //   })

                                              ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                  const rightTrimRaw = getFieldValue(`${tab.code}right_trim${widthIndex}`);
                                                  const minWidth = Number(getFieldValue(`${tab.code}minWidth${widthIndex}`)) || 0;
                                                  const maxWidth = Number(getFieldValue(`${tab.code}maxWidth${widthIndex}`)) || 0;

                                                  // ✅ Only skip if field is truly empty
                                                  if (value === undefined || value === "" ||
                                                      rightTrimRaw === undefined || rightTrimRaw === "") {
                                                    return Promise.resolve();
                                                  }

                                                  const left = Number(value);
                                                  const right = Number(rightTrimRaw);

                                                  if ((left + right) >= (maxWidth - minWidth)) {
                                                    return Promise.reject(
                                                      new Error(
                                                        "Total edge trim must be less than difference of Deckle Width min and max"
                                                      )
                                                    );
                                                  }

                                                  return Promise.resolve();
                                                }
                                              })
                                            ]}
                                          // initialValue={widthEle.left_edge_trim}
                                          >
                                            <Input size="small" placeholder="Left Trim"
                                              disabled={action == "view"}
                                              onChange={e => {
                                                const value = e.target.value;

                                                // 1️⃣ Update form value
                                                form.setFieldsValue({
                                                  [`${tab.code}left_trim${widthIndex}`]: value,
                                                });

                                                // 2️⃣ Recalculate validation condition
                                                const left = Number(value);
                                                const right = Number(
                                                  form.getFieldValue(`${tab.code}right_trim${widthIndex}`)
                                                );
                                                const minWidth = Number(
                                                  form.getFieldValue(`${tab.code}minWidth${widthIndex}`)
                                                ) || 0;
                                                const maxWidth = Number(
                                                  form.getFieldValue(`${tab.code}maxWidth${widthIndex}`)
                                                ) || 0;

                                                // 3️⃣ If condition is now valid → clear BOTH errors
                                                if (
                                                  left &&
                                                  right &&
                                                  ((left + right) < (maxWidth - minWidth))
                                                ) {
                                                  form.setFields([
                                                    {
                                                      name: `${tab.code}left_trim${widthIndex}`,
                                                      errors: [],
                                                    },
                                                    {
                                                      name: `${tab.code}right_trim${widthIndex}`,
                                                      errors: [],
                                                    },
                                                  ]);
                                                }
                                                updateWidthField(tab.code, widthIndex, "left_edge_trim", e.target.value);
                                              }}
                                            />
                                          </Form.Item>
                                        </Col>

                                        {/* Right Trim */}
                                        <Col span={3}>
                                          <Form.Item                                          
                                            name={`${tab.code}right_trim${widthIndex}`}
                                            rules={[
                                              { required: true, message: "This field is required" },
                                              {
                                                pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                                message: "Up to 3 decimal point values are accepted",
                                              },
                                              // ({ getFieldValue }) => ({
                                              //   validator(_, value) {
                                              //     const leftTrim = getFieldValue(`${tab.code}left_trim${widthIndex}`);
                                              //     const minWidth = Number(getFieldValue(`${tab.code}minWidth${widthIndex}`)) || 0;
                                              //     const maxWidth = Number(getFieldValue(`${tab.code}maxWidth${widthIndex}`)) || 0;

                                              //     if (!value) return Promise.resolve();

                                              //     if ((leftTrim + Number(value)) >= (maxWidth - minWidth)) {
                                              //       return Promise.reject(
                                              //         new Error("Total edge trim must be less than difference of Deckle Width min and max")
                                              //       );
                                              //     }

                                              //     return Promise.resolve();
                                              //   }
                                              // })

                                              ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                  const leftTrimRaw = getFieldValue(`${tab.code}left_trim${widthIndex}`);
                                                  const minWidth = Number(getFieldValue(`${tab.code}minWidth${widthIndex}`)) || 0;
                                                  const maxWidth = Number(getFieldValue(`${tab.code}maxWidth${widthIndex}`)) || 0;

                                                  // ✅ Skip validation if either field is empty
                                                  if (
                                                    value === undefined || value === "" ||
                                                    leftTrimRaw === undefined || leftTrimRaw === ""
                                                  ) {
                                                    return Promise.resolve();
                                                  }

                                                  const left = Number(leftTrimRaw);
                                                  const right = Number(value);

                                                  if ((left + right) >= (maxWidth - minWidth)) {
                                                    return Promise.reject(
                                                      new Error(
                                                        "Total edge trim must be less than difference of Deckle Width min and max"
                                                      )
                                                    );
                                                  }

                                                  return Promise.resolve();
                                                }
                                              })
                                            ]}
                                          // initialValue={widthEle.right_edge_trim}
                                          >
                                            <Input size="small" placeholder="Right Trim"
                                              disabled={action == "view"}
                                              onChange={e => {
                                                const value = e.target.value;

                                                form.setFieldsValue({
                                                  [`${tab.code}right_trim${widthIndex}`]: value,
                                                });

                                                const right = Number(value);
                                                const left = Number(
                                                  form.getFieldValue(`${tab.code}left_trim${widthIndex}`)
                                                );
                                                const minWidth = Number(
                                                  form.getFieldValue(`${tab.code}minWidth${widthIndex}`)
                                                ) || 0;
                                                const maxWidth = Number(
                                                  form.getFieldValue(`${tab.code}maxWidth${widthIndex}`)
                                                ) || 0;

                                                if (
                                                  left &&
                                                  right &&
                                                  ((left + right) < (maxWidth - minWidth))
                                                ) {
                                                  form.setFields([
                                                    {
                                                      name: `${tab.code}left_trim${widthIndex}`,
                                                      errors: [],
                                                    },
                                                    {
                                                      name: `${tab.code}right_trim${widthIndex}`,
                                                      errors: [],
                                                    },
                                                  ]);
                                                }
                                                updateWidthField(tab.code, widthIndex, "right_edge_trim", e.target.value);
                                              }}
                                                 />
                                          </Form.Item>
                                        </Col>

                                        {/* Effective Deckle Length */}
                                        <Col span={5}>
                                          <DeckleWidthInputs>
                                            <Form.Item
                                              name={tab?.code + "effective_dlength" + widthIndex}
                                              rules={[]}
                                            // initialValue={widthEle.effective_deckle_length}
                                            >
                                              <Input size="small" placeholder="Min" disabled />
                                            </Form.Item>

                                            <Form.Item
                                              name={tab?.code + "dlength_unit" + widthIndex}
                                              rules={[]}
                                              initialValue={lengthUnit[widthEle?.unit]?.displayName}
                                            >
                                              <Input size="small" placeholder="Unit" disabled />
                                            </Form.Item>
                                          </DeckleWidthInputs>
                                        </Col>

                                        {/* Maximum allowed trim loss */}
                                        <Col span={5}>
                                          <DeckleWidthInputs>
                                            <Form.Item
                                              name={tab?.code + "trim_loss" + widthIndex}
                                              rules={[]}
                                              initialValue={Number(widthEle?.max_allowed_trim_loss)?.toFixed(3)}
                                            >
                                              <Input size="small" placeholder="Min" disabled />
                                            </Form.Item>

                                            <Form.Item
                                              name={tab?.code + "trim_loss_unit" + widthIndex}
                                              rules={[]}
                                              initialValue={"%"}
                                            >
                                              <Input size="small" placeholder="Unit" disabled />
                                            </Form.Item>
                                          </DeckleWidthInputs>
                                        </Col>
                                      </DeckleBodyRow>
                                    ))
                                  }

                                </DeckleColWrapper>
                              </DeckleTableContainer>
                            </DeckleWrapper>
                          </Panes>
                        ))}
                      </Tabs>
                    </StyledTab>

                    <div
                        style={{
                          marginTop: "8px",
                          display: "flex",
                          justifyContent: "flex-end"
                        }}
                      >
                        <Form.Item
                          name="fixed_edge_trim_config"
                          valuePropName="checked"
                          initialValue={
                            action === "add"
                              ? false
                              : (fixedEdgeTrimConfig ?? false)
                          }
                          style={{ marginBottom: 0 }}
                        >
                          <Checkbox
                            disabled={action === "view"}
                            onChange={(e) => setFixedEdgeTrimConfig(e.target.checked)}
                          >
                            <span
                              style={{
                                color: "#323130",
                                fontSize: "12px",
                                fontFamily: "var(--sf-pro-text)"
                              }}
                            >
                              Fixed edge trim Configuration
                            </span>
                          </Checkbox>
                        </Form.Item>
                    </div>
                    {/* </Row> */}
                  </Col>
                </Row>) : (null)}

              {/* <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Deckle Width Range</label>
                        <p>
                          The minimum and maximum deckle width of this rewinder
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="minimum_width"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                                // {
                                //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                //   message: "Min. width cannot be zero",
                                // },
                                {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Min. width cannot be zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                              className=""
                              //onChange={setTrimLoss}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : rewinderDetails?.minimum_width
                              }
                            >
                              <Input
                                placeholder="Min width"
                                onChange={validateWidth}
                                disabled={action == "view"}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="maximum_width"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                                // {
                                //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                //   message: "Max. width cannot be zero",
                                // },
                                {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Max. width cannot be zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : rewinderDetails?.maximum_width
                              }
                              className=""
                              //onChange={setTrimLoss}
                            >
                              <Input
                                placeholder="Max width"
                                disabled={action == "view"}
                                onChange={validateWidth}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="length_unit"
                              initialValue={
                                action == "add"
                                  ? unitData.units_management.length.default
                                  : rewinderDetails.units.maximum_width
                              }
                            >
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                onChange={onLengthUnitChange}
                                disabled={action == "view"}
                              >
                                {unitData.units_management.length.data.map(
                                  (deckleWidth) => (
                                    <Option key={deckleWidth}>
                                      {lengthUnit[deckleWidth].displayName}
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>

                        {widthValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Max width cannot be less than Min width
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Edge Trim</label>
                        <p>Default left and right edge trim on the rewinder</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex threeFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="left_edge_trim"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern:
                                //     /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : rewinderDetails?.left_edge_trim
                              }
                              className=""
                              //onChange={setTrimLoss}
                            >
                              <Input
                                placeholder="Left Trim"
                                disabled={action == "view"}
                                onChange={validateEdgeTrim}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="right_edge_trim"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                // {
                                //   pattern:
                                //     /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/,

                                //   message: "Invalid format",
                                // },
                                {
                                  pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                  message:
                                    "Upto 3 decimal point values is accepted",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : rewinderDetails?.right_edge_trim
                              }
                              className=""
                              //onChange={setTrimLoss}
                            >
                              <Input
                                placeholder="Right Trim"
                                disabled={action == "view"}
                                onChange={validateEdgeTrim}
                              />
                            </Form.Item>
                          </div>
                          <div
                            className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name="edge_unit"
                              initialValue={
                                action == "add"
                                  ? unitData.units_management.length.default
                                  : rewinderDetails.units.right_edge_trim
                              }
                            >
                              <Select
                                placeholder="Unit"
                                suffixIcon={<DownArrowDraw />}
                                onChange={onEdgeUnitChange}
                                disabled={action == "view"}
                              >
                                {unitData.units_management.length.data.map(
                                  (deckleWidth) => (
                                    <Option key={deckleWidth}>
                                      {lengthUnit[deckleWidth].displayName}
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        {edgeTrimValidationError ? (
                          <span
                            className="errorText"
                            style={{ color: "#ea4e2c" }}
                          >
                            Total edge trim should be less than difference of
                            deckle range
                          </span>
                        ) : null}
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Effective Deckle Length</label>
                        <p>
                          Effective deckle length to match orders after
                          adjusting for edge trim
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="effective_deckle_length"
                          //rules={[{}]}
                          className=""
                          initialValue={
                            action == "add"
                              ? ""
                              : rewinderDetails?.effective_deckle_length
                          }
                        >
                          <Input placeholder="" disabled />
                        </Form.Item>
                        <span
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "20px",
                            fontSize: "14px",
                            color: "#a19f9d",
                            fontFamily: " var(--sf-pro-text)",
                          }}
                        >
                          {selectedLengthUnit}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Allowed Trim Loss</label>
                        <p>The maximum allowed trim loss in percentage</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="maximum_loss"
                          //rules={[{}]}
                          className=""
                          initialValue={
                            action == "add" ? "" : rewinderDetails?.maximum_loss
                          }
                        >
                          <Input placeholder="" disabled />
                        </Form.Item>
                        <span className="nonEditable">%</span>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Rewinder Capacity</label>
                        <p>The daily rewinding capacity of the rewinder</p>
                      </div>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Row className="centerAlign">
                        <Col span={24} className="d-flex twoFields">
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DisabledStyles>
                              <Form.Item
                                name="capacity"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: /^[0-9]*$/,
                                    message: "Invalid format",
                                  },
                                  // {
                                  //   pattern: new RegExp(/^0*[1-9]\d*$/),
                                  //   message: "Capacity cannot be zero",
                                  // },
                                  {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Capacity cannot be zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? ""
                                    : rewinderDetails?.capacity
                                }
                                className=""
                              >
                                <Input
                                  placeholder={"Enter the prod. capacity"}
                                  disabled={action == "view"}
                                  className="disabled-check"
                                  //style={{ textTransform: "capitalize" }}
                                />
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                          <div className="boxFormType">
                            <DisabledStyles>
                              <Form.Item
                                name="capacity_unit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                initialValue={
                                  action == "add"
                                    ? unitData.units_management.weight.default
                                    : rewinderDetails?.units?.capacity
                                }
                                className=""
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                >
                                  {unitData.units_management.weight.data.map(
                                    (weight) => (
                                      <Option key={weight}>
                                        {weightUnit[weight].displayName +
                                          " / day"}
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </DisabledStyles>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                  <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Cutter Specification</h2>
                    <p>
                      The cutter specification will be used in deckle matching
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Maximum Cutters</label>
                        <p>The maximum number of cutters which can be placed</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="maximum_cutters"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^[0-9]*$/,
                              message: "Invalid format",
                            },
                            // {
                            //   pattern: new RegExp(/^0*[1-9]\d*$/),
                            //   message: "Max. cutters cannot be zero",
                            // },
                            {
                                  validator(_, value) {
                                    if (value && value == 0) {
                                      return Promise.reject(
                                        "Max. cutters cannot be zero"
                                      );
                                    } else{
                                      return Promise.resolve();
                                    }
                                  },
                                },
                          ]}
                          initialValue={
                            action == "add"
                              ? ""
                              : rewinderDetails?.maximum_cutters
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              //   action === "view"
                              //     ? ""
                              //     :
                              "Enter maximum cutters"
                            }
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                      
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Loading Stands</label>
                            <p>Number of loading stands available</p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="loading_stands"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^[1-4]$/,
                                  message:
                                    "At max 4 loading stands are allowed per rewinder",
                                },
                              ]}
                              initialValue={
                                action === "add" ? 1 : rewinderDetails.loading_stands
                              }
                              className=""
                            >
                              <Input
                                placeholder={
                                  //   action === "view"
                                  //     ? ""
                                  //     :
                                  "Count of loading stands"
                                }
                                onChange={onLoadingStandChange}
                                style={{ textTransform: "capitalize" }}
                                disabled={action === "view"}
                              />
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Multy-Ply Specifications</h2>
                    <p>Specifications needed for producing multi-ply product</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Multi-Ply Capability</label>
                        <p>Does this rewinder process multi-ply orders?</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="ply"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={
                            action == "add" ? "no" : plyStatus
                          }
                        >
                          <Radio.Group
                            disabled={action == "view"}
                            options={plyStatusData}
                            value={plyStatus}
                            optionType="button"
                            buttonStyle="solid"
                            onChange={onPlyStatusChange}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                   
                  {plyStatus == 'yes' &&
                    <>
                      <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Multi-Ply Setup</label>
                            <p>
                              Way the rewinder is setup to process multi-plied
                              orders
                            </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="setup"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={
                                action === "add"
                                  ? "single"
                                  : rewinderDetails.multi_ply_setup
                              }
                              className=""
                            >
                              <Select
                                placeholder="Setup"
                                suffixIcon={<DownArrowDraw />}
                                onChange={onSetupChange}
                                disabled={action == "view"}
                              >
                                {setupData.map((data) => (
                                  <Option key={data.value}>{data.label}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>
                     
                      {(allowedValues.includes(parseInt(checkboxCount, 10)) || form.getFieldValue('setup') == 'single') && <Row className="centerAlign">
                        <Col span={12}>
                          <div className="boxFieldTitle">
                            <label>Ply Range</label>
                            <p>Ply count that can be processed on the rewinder </p>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="boxFormType">
                            <Form.Item
                              name="range"
                              rules={[
                                // {
                                //   required: true,
                                //   message: "This field is required",
                                // },
                                {
                                  validator(_, value) {
                                    if (!value || value.length === 0) {
                                      return Promise.reject(new Error("This field is required"));
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}

                              initialValue={selectedRange}
                              className=""
                            >
                              <div class="checkboxFilt">
                                <Checkbox.Group
                                  value={selectedRange.map(String)} // Convert selectedRange to string values
                                  onChange={handleCheckboxChange}
                                  style={{ width: "100%" }}
                                  disabled={action == "view"}
                                >
                                  <Row gutter={16}>{checkboxes}</Row>
                                </Checkbox.Group>
                              </div>
                            </Form.Item>
                          </div>
                        </Col>
                      </Row>}
                    </>}

                </Col>
              </Row>
             
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to this rewinder</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Status</label>
                        <p>
                          The rewinder can only be used if it is set to active
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Form.Item
                          name="status"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          initialValue={
                            action == "add" ? "active" : rewinderDetails?.status
                          }
                        >
                          <Radio.Group
                            disabled={action == "view"}
                            options={userStatusData}
                            value={userStatus}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>Any other information related to this rewinder</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            // rules={[{ required: true }]}
                            className=""
                            initialValue={
                              action == "add" ? "" : rewinderDetails?.remarks
                            }
                          >
                            <TextArea
                              disabled={action == "view"}
                              maxLength={200}
                              style={{ height: 90 }}
                              placeholder={
                                action === "add" || action === "edit"
                                  ? "Enter remarks"
                                  : ""
                              }
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={viewDelete}
        icon={warning}
        cancelAction={modalCancelDelete}
        confirmAction={modalConfirmDelete}
      >
        <span>Delete Rewinder ?</span>
        <p>
          You are about to delete the rewinder. Once deleted it cannot be
          recovered. Are you sure you want to continue ?
        </p>
      </ConfirmationModal>

      {addToastr && (
        <AlertContainer color="green toaster" icon={alertGreen} msg={addResp} />
      )}
      {deleteToastr && (
        <AlertContainer color="red toaster" icon={alertRed} msg={addResp} />
      )}
    </RightLayoutContainer>
  ) : null;
};

export default AddEditViewRewinder;
